module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 27
// module chunks = 418